import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'hex-wrapper',
  templateUrl: './hex-wrapper.component.html',
  styleUrls: ['./hex-wrapper.component.scss']
})
export class HexWrapperComponent {
}
